import React from "react";
import Header from "./Header";
import Recommendation from "./Recommendation";
import ReferCarePlan from "./ReferCarePlan";
import { getDecodedToken } from "../../../utils/localStorage";
import { GENERAL_SPECIALITY_ID } from "../../../envConstants";

const WelcomePage: React.FC = () => {
  const tokenData: any = getDecodedToken();
  const doctorDetails: any = tokenData?.user || {};
  return (
    <main className="flex flex-col w-full h-auto gap-[12px] rounded-b-[30px] bg-custom-gradient">
      <Header isRemoteCare />
      {/* <section className="flex flex-col mt-3 w-full">
        <div className="flex flex-col justify-center px-6 w-full text-gray-800">
          <h1 className="text-xl leading-snug text-left">Welcome,</h1>
          <h2 className="text-2xl font-semibold leading-none text-left">
            {doctorDetails?.name}
          </h2>
        </div>
      </section> */}
      {(!doctorDetails?.speciality ||
        (doctorDetails?.speciality &&
          doctorDetails?.speciality === GENERAL_SPECIALITY_ID)) && (
        <Recommendation />
      )}
      <ReferCarePlan />
    </main>
  );
};

export default WelcomePage;
